// extracted by mini-css-extract-plugin
export default {"asset-protection-chart":"styles_asset-protection-chart__OdrKG"};